import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "./Firebase";

// Define creator profile fields
type CreatorProfileData = {
  username?: string;
  bio?: string;
  avatarUrl?: string;
  patreonUrl?: string;
};

// Register user and create Firestore entries
export const registerUser = async (
  email: string,
  password: string,
  role: string,
  extraData: CreatorProfileData = {}
) => {
  try {
    console.log("Registering user:", email, role);
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    console.log("Created user:", user.uid);

    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      email: user.email,
      role,
      createdAt: new Date(),
    });

    console.log("User profile saved");

    if (role === "creator") {
      await setDoc(doc(db, "creators", user.uid), {
        uid: user.uid,
        username: extraData.username || "",
        bio: extraData.bio || "",
        avatarUrl: extraData.avatarUrl || "",
        patreonUrl: extraData.patreonUrl || "",
        joinedAt: new Date(),
      });
      console.log("Creator profile saved");
    }

    return userCredential;
  } catch (error) {
    console.error("Registration error:", error);
    throw error;
  }
};

// Log in user
export const loginUser = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

// Log out user
export const logoutUser = () => {
  return signOut(auth);
};
